<template>
  <div class="dashboard-table">
    <div v-loading="loading"
         element-loading-text="玩命加载中……"
         element-loading-spinner="el-icon-loading">
      <el-table
          :data="tableData"
          stripe
          style="width: 100%">
        <el-table-column prop="index" label="序号" width="80" align="left">
          <template slot-scope="scope">
            <span>{{ scope.$index + 1 }}</span>
          </template>
        </el-table-column>
        <el-table-column
            prop="name"
            label="红人昵称"
            min-width="120" sortable>
        </el-table-column>
        <el-table-column
            v-for="(v,k) in columns"
            :key="k"
            :prop="typeof(v.value)=='string'?v.value:''"
            :label="v.title"
            :min-width="v.width"
            :show-overflow-tooltip="true"
            :header-align="v.header_align?v.header_align:'left'"
            :align="v.align?v.align:'left'"
            :sortable="v.sortable?v.sortable:true">
          <template slot-scope="scope">
            <span>{{ scope.row[v.value] || '-' }}</span>
          </template>
        </el-table-column>

      </el-table>

    </div>

  </div>
</template>

<script>
import { getDashboardArtistPlatformMonth } from "@/api/dashboard";

export default {
  name: "ArtistPlatformData",
  data() {
    return {
      loading: false,
      columns: [],
      searchCondition: {
        year: null,
        month: null,
      },
      tableData: []
    }
  },
  mounted() {

  },
  methods: {
    init(searchCondition) {
      this.searchCondition = searchCondition
      this.getData()
    },
    async getData() {
      this.loading = true
      let { cols, data } = await getDashboardArtistPlatformMonth(this.searchCondition).then(res => {
        return res.model
      })

      this.columns = cols;
      this.$nextTick(() => {
        this.tableData = data
      })
      this.loading = false
    },
    getColumns() {
      this.columns = [
        {
          title: '抖音',
          value: 'douyin',
          width: 40
        },
        {
          title: '小红书',
          value: 'xiaohongshu',
          width: 40
        }, {
          title: '微博',
          value: 'weibo',
          width: 40
        },
      ]

    }
  }
}
</script>

<style scoped>

</style>